<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-warehouse-select
            v-model="filter.warehouseIds"
            multiple
            :self="false"
            placeholder="仓库"
            width="165px"
        ></gj-warehouse-select>
        <gj-select
          :options="options.typeAll"
          type="multi-check"
          :filterable="false"
          placeholder="全部类型"
          width="140px"
          v-model="filter.outboundType"
        ></gj-select>
        <gj-select
          :options="options.consumeStatusOption"
          placeholder="扣减状态"
          width="140px"
          v-model="filter.consumeStatus"
        ></gj-select>
        <gj-select-date-picker
            class="main-gj-select-date-picker"
            type="daterange"
            :width="['155px']"
            v-model="filter.date"
            :options="options.date"
        ></gj-select-date-picker>
        <gj-input
          v-model="filter.msku"
          placeholder="MSKU"
          width="180px"
          :matching.sync="filter.matchType"
        ></gj-input>
        <gj-select-input
          v-model="filter.keyword"
          :options="options.keyword"
          :width="['120px', '150px']"
        ></gj-select-input>
        <template #right>
          <gj-tool-group
              help
              :download="$permission('storageCostBatchConsume:export')"
              download-url="/supply/storageCostBatchConsume/export"
              :download-params="globalParams"></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        size="has-picture"
        show-summary
        :summary-object="summaryObject"
        :index="false"
        name="deduction-record"
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :default-sort="defaultSort"
        :pagination="pagination"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:header:consumeStatus>
          扣减状态
          <gj-help>
            <div>使用说明：</div>
            <div>由于亚马逊已接收库存报告的不稳定性，会存在商品已入库但未生成批次造成异常扣减的情况，出现此状态系统将会自动对数据进行轮循校验，修正扣减状态。</div>
            <div>异常扣减的记录默认使用上一次的成本数据，修正后会取正确已维护的成本。</div>
          </gj-help>
        </template>
        <!-- 自定义cell -->
        <template v-slot:picture="{ row }">
          <div>{{ row }}</div>
        </template>
        <template v-slot:consumeStatus="{ row }">
          <gj-tag :color="row.consumeStatus | optionColor(options.consumeStatusOption)" type="text">
            {{row.consumeStatus | optionText(options.consumeStatusOption)}}
          </gj-tag>
        </template>
      </gj-table>
    </template>
    <template v-if="userGuideState" #base-content>
        <new-user-guide v-if="userGuideState" ref="newUserGuide"></new-user-guide>
      </template>
  </app-base-main>
</template>

<script>
import { isMeaningfulMixin, queryMixin, selectionMixin, userGuideMixin} from "@/minxins";
import { convertToDate } from "@/utils/date.util.js"
import { storageCostBatchConsumePage } from "@/api/finance.js";
import { amount } from "@/filters"
import { consumeStatusOption } from "@/utils/options.js"
import NewUserGuide from "./components/new-user-guide"

export default {
  name: "deduction-record",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin,userGuideMixin],
  components: {NewUserGuide},

  data() {
    return {
      isInitParams: false,
      loading: false, // 加载
      summaryObject: null,
      defaultSort: {prop: 'beijingTime', order: 'descending'},
      transportOption: [],
      pagination: {},
      tableData: [], // 表格数据
      filter: {
        outboundType: [],
        warehouseIds: [],
        consumeStatus: null,
        date: {
          key: '1',
          value: [],
        },
        msku: null,
        matchType: 'like',
        keyword: {
          key: "outboundCode",
          value: "",
        },
      },
      options: {
        date: [
          {id: "1", text: "出库日期(站点时区)"},
          {id: "2", text: "出库日期(北京时间)"}
        ],
        typeAll: [
          { id: "sale_order", text: '订单发货' },
          { id: "inventory_adjustment", text: '库存调整' },
          { id: "fba_removal", text: '库存移除' },
          { id: "inventory_diff", text: '期初调整' },
        ],
        keyword: [
          { id: "outboundCode", text: '单据号' },
          { id: "batchNumber", text: '批次号' },
        ],
        consumeStatusOption: consumeStatusOption
      },
      columns: [
        {id: 'warehouseName',fixed:"left", header: '仓库', field: 'warehouseName', width: '165px', default: true},
        {id: 'marketTime',fixed:"left", header: '出库日期(站点时区)', field: 'marketTime', width: '165px', default: true, disabled: true, sortable: true},
        {id: 'beijingTime',fixed:"left", header: '出库日期(北京时区)', field: 'beijingTime', width: '165px', default: true, disabled: true, sortable: true},
        {id: 'msku',fixed:"left", header: 'MSKU', field: 'msku', minWidth: '178px', default: true, disabled: true},
        {id: 'outboundCode', header: '单据号', field: 'outboundCode', width: '165px', default: true},
        {id: 'outboundTypeName', header: '类型', field: 'outboundTypeName', width: '95px', default: true},
        {id: 'batchNumber', header: '批次号', field: 'batchNumber', width: '155px', default: true},
        {id: 'quantity', header: '扣减数量', summary:true, scale:2, field: 'quantity', width: '155px', align: 'right', default: true},
        {id: 'consumeStatus', header: 'slot:consumeStatus', field: 'slot:consumeStatus', minWidth: '100px', align: 'center', default: true},
        {id: 'purchaseCost', header: '采购成本', summary:true, field: 'purchaseCost', scale: 4, prefix:"purchaseCurrencySymbol", width: '155px', align: 'right', default: true},
        {id: 'arrivalCost', header: '到库成本', summary:true, field: 'arrivalCost', scale: 4, prefix:"purchaseCurrencySymbol", width: '155px', align: 'right', default: true},
        {id: 'totalPurchaseCost', header: '总采购成本', summary:true, prefix:"purchaseCurrencySymbol", scale:4, field: 'totalPurchaseCost', width: '155px',  align: 'right',default: true},
        {id: 'totalArrivalCost', header: '总到库成本', summary:true, prefix:"purchaseCurrencySymbol", scale:4, field: 'totalArrivalCost', width: '155px', default: true, align: 'right',},
      ],
    };
  },
  methods: {
    // 初始化
    $gjQueryInitParams() {
      return {
        filter: {
          outboundType: [],
          warehouseIds: [],
          consumeStatus: null,
          date: {
            key: '1',
            value: [],
          },
          msku: '',
          matchType: 'like',
          keyword: {
            key: "outboundCode",
            value: "",
          },
        },
      }
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          outboundType: this.filter.outboundType,
          warehouseIds: this.filter.warehouseIds,
          consumeStatus: this.filter.consumeStatus,
          accurateQuery: this.filter.matchType === 'exact',
          msku: this.filter.msku
        },
        ...this.queryPagination,
        ...this.querySort
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.value && this.filter.date.value.length !== 0) {
        if (this.filter.date.key === '1') {
          params.model.beginCreateDate = convertToDate(this.filter.date.value[0])
          params.model.endCreateDate = convertToDate(this.filter.date.value[1])
        }else {
          params.model.bjBeginCreateDate = convertToDate(this.filter.date.value[0])
          params.model.bjEndCreateDate = convertToDate(this.filter.date.value[1])
        }
      }
      this.storageCostBatchConsumePage(params)
    },
    disabledDate(time) {
      return time.getTime() > new Date().getTime(); // 限制今天以后
    },
    // 查询list数据
    async storageCostBatchConsumePage(params) {
      this.loading = true;
      this.globalParams = params;
      try {
        let data = await storageCostBatchConsumePage(params)
        this.pagination = this.getPagination(data);
        this.tableData = data.records || []
        this.summaryObject = data.statisticRecord || {}
        this.summaryObject.purchaseCost = this._.round(Number(this.summaryObject.totalPurchaseCost) / Number(this.summaryObject.quantity), 2);
        this.summaryObject.arrivalCost = this._.round(Number(this.summaryObject.totalArrivalCost) / Number(this.summaryObject.quantity), 2);
        this.summaryObject.purchaseCost = amount(this.summaryObject.purchaseCost)
        this.summaryObject.arrivalCost = amount(this.summaryObject.arrivalCost)
      } finally {
        this.loading = false
      }
    },
    // 初始化查询条件
    initParams(batchNumber, isQuery) {
      if (batchNumber) {
        this.filter.outboundType = []
        this.filter.warehouseIds = []
        this.filter.date.key = "1"
        this.filter.date.value = []
        this.filter.keyword.key = "batchNumber"
        this.filter.keyword.value = batchNumber
        isQuery && this.$gjNoticeQuery()
        sessionStorage.removeItem('batchNumber')
      }
    }
  },
  created() {
    this.sort.prop = 'beijingTime';
    let batchNumber = sessionStorage.getItem('batchNumber')
    this.initParams(batchNumber, false)
  },
  activated() {
    this.sort.prop = 'beijingTime';
    let batchNumber = sessionStorage.getItem('batchNumber')
    this.initParams(batchNumber, true)
  }
};
</script>

<style scoped lang="scss">
.date-picker {
  width: 136px;
}
/deep/.main-gj-select-date-picker {
  .gj-select {
    .el-input {
      .el-input__inner {
        border: 1px solid #DCDFE6 !important;
      }
    }
  }
}
</style>
